import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import { SIGNUP_FORM_TYPES } from 'dpl/shared/constants/shared';
import { CONSTRAINT_MESSAGES } from 'dpl/shared/validations/constraints';
import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import ErrorWrapper from 'dpl/form/components/ErrorWrapper';
import EmailUnavailableErrorMessage from 'dpl/shared/validations/EmailUnavailableErrorMessage';
import UserAuthModalLoginForm from 'dpl/components/UserAuthModal/UserAuthModalLoginForm';
import UserAuthModalForgotPasswordForm from 'dpl/components/UserAuthModal/UserAuthModalForgotPasswordForm';
import FullPageQuizTextInput from 'dpl/components/FullPageQuiz/FullPageQuizTextInput';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';

const INPUT_NAME = 'buyer_profile_attributes.user_attributes.email';

const { LOGIN, FORGOT_PASSWORD } = SIGNUP_FORM_TYPES;

export default class QuizEmailQuestion extends Component {
  static propTypes = {
    /* eslint-disable react/no-unused-prop-types */
    formErrors: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    /* eslint-enable react/no-unused-prop-types */
    onChange: PropTypes.func.isRequired,
    handleNextClick: PropTypes.func.isRequired,
    buyerApplicationData: PropTypes.shape({
      fetch: PropTypes.func.isRequired
    }).isRequired,
    resetFormState: PropTypes.func.isRequired,
    currentUser: PropTypes.shape({
      fetch: PropTypes.func.isRequired
    }).isRequired,
    isValid: PropTypes.bool.isRequired
  };

  state = {
    signupFormType: null
  };

  handleSuccessfulLogin = () => {
    const {
      buyerApplicationData,
      handleNextClick,
      resetFormState,
      currentUser
    } = this.props;

    // clear form so it can update with server values after user logs in
    resetFormState(() => {
      currentUser.fetch();
      buyerApplicationData.fetch().then(() => {
        this.setState({ signupFormType: null }, handleNextClick);
      });
    });
  };

  showLoginForm = () => this.setState({ signupFormType: LOGIN });

  showForgotPasswordForm = () =>
    this.setState({ signupFormType: FORGOT_PASSWORD });

  hideLoginForm = () => this.setState({ signupFormType: null });

  get errors() {
    const {
      formErrors: { [INPUT_NAME]: errors = [] }
    } = this.props;

    return errors.map(err =>
      err === CONSTRAINT_MESSAGES.EMAIL_UNAVAILABLE ? (
        <EmailUnavailableErrorMessage onLoginClick={this.showLoginForm} />
      ) : (
        err
      )
    );
  }

  render() {
    const { onChange, formState, isValid, handleNextClick } = this.props;
    const { signupFormType } = this.state;

    return (
      <div className="AdoptionApplicationQuizEmailQuestion">
        <FullPageQuizQuestion
          title="Enter your email address"
          subtitle="We'll let you know when your breeder contacts you."
          icon="mailbox"
          isValid={isValid}
          handleNextClick={handleNextClick}
        >
          <ErrorWrapper errors={this.errors}>
            <FullPageQuizTextInput
              type="text"
              value={get(formState, INPUT_NAME) || ''}
              onChange={onChange}
              name={INPUT_NAME}
              autoCapitalize="none"
              placeholder="Email address"
            />
          </ErrorWrapper>
        </FullPageQuizQuestion>
        {signupFormType && (
          <MiniOverlayModal
            className="UserAuthModal"
            onCloseClick={this.hideLoginForm}
          >
            {signupFormType === LOGIN ? (
              <UserAuthModalLoginForm
                loginOnly
                onPasswordResetClick={this.showForgotPasswordForm}
                onAuth={this.handleSuccessfulLogin}
              />
            ) : (
              <UserAuthModalForgotPasswordForm
                onLoginClick={this.showLoginForm}
              />
            )}
          </MiniOverlayModal>
        )}
      </div>
    );
  }
}
